/**
 * The Asset Library's footer (selection label + one action button) is shared
 * chrome across every tab, but what it says and does is entirely per-tab —
 * Slide Templates inserts, Brand Templates routes into Apply Brand, and a
 * future tab will bring its own verb again. Each tab panel reports its
 * current footer state up to AssetLibraryContent via a callback (the same
 * pattern SlideTemplatesPanel already used for its own selection state);
 * AssetLibraryContent just renders whatever the active tab last reported.
 */
export interface AssetLibraryFooterState {
  /** Rendered where a plain "N selected" used to be — e.g. "3 selected" or
   *  "Northwind Advisory selected". */
  readonly selectionLabel: string;
  /** Button text — changes with in-flight state (e.g. "Inserting…"). */
  readonly actionLabel: string;
  readonly actionDisabled: boolean;
  readonly onAction: () => void;
}

/** Shown for tabs that report no footer state at all (still-loading, or a
 *  "coming soon" placeholder tab with no action of its own). */
export const DEFAULT_ASSET_LIBRARY_FOOTER_STATE: AssetLibraryFooterState = {
  selectionLabel: "0 selected",
  actionLabel: "Insert into deck",
  actionDisabled: true,
  onAction: () => undefined,
};
